import { FunctionComponent } from 'react';
import { useTranslation } from 'next-i18next';

interface Props {
  title: string;
  isSolved: boolean;
}

const Title: FunctionComponent<Props> = ({ title, isSolved }) => {
  const { t } = useTranslation('common');
  
  return (
    <div className="flex items-center space-x-4">
      <a id="title-exercise">
        <h2 className="text-white text-xl font-bold inline-block my-4">{title}</h2>
      </a>

      {isSolved && (
        <span className="inline-block rounded-sm text-platzi-green bg-platzi-dark-second duration-300 text-xs md:font-bold mt-0 mr-1 px-1 py-1 md:mr-2  md:px-3 md:py-1 opacity-90 hover:opacity-100">
          {t('challenges.solved')}
        </span>
      )}
    </div>
  );
};

export default Title;
